import React from "react";
import { NavLink } from "react-router-dom";

const Nav = ({ stopfuntion }) => {
  return (
    <>
      <div className="app_footer">
        <ul className="footer_menu_list">
          <li>
            <NavLink to="/" end>
              <i className="footer_icon"></i>
              <span>Watchlist</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/trades">
              <i className="footer_icon"></i>
              <span>Trades</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/portfolio">
              <i className="footer_icon"></i>
              <span>Portfolio</span>
            </NavLink>
          </li>
          <li>
            <NavLink to="/account">
              <i className="footer_icon"></i>
              <span>Account</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Nav;
